import CartPage from 'pages/CartPage/CartPage';

export default CartPage;
